import React from 'react';
import AuditsTable from './AuditsTable';
import AuditsPanelContainer from './AuditsPanelContainer';

const AuditsPanelFull = ({
  category,
  code,
  onChange,
  url,
}) => (
  <AuditsPanelContainer
    category={category}
    className="aridhia-audits-panel-full"
    code={code}
    onChange={onChange}
    url={url}
  >
    <AuditsTable category={category} code={code} />
  </AuditsPanelContainer>
);

export default AuditsPanelFull;
